export function getPackages(state) {
  return state.packages;
}

export function getPagination(state) {
  return state.pagination;
}